// extracted by mini-css-extract-plugin
export default {"fixSectionWrapper":"dd085fdb9a3b","fixSection":"c73f245dfd26"};